import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

export enum fiCustomerPaymentStatus {
    Freemium = 1,
    Paying = 2,
}

export const fiCustomerPaymentStatuses = [
    {
        id: fiCustomerPaymentStatus.Freemium,
        textId: 'Freemium customer',
    },
    {
        id: fiCustomerPaymentStatus.Paying,
        textId: 'Paying customer',
    },
];

export const fiCustomerPaymentStatusesShortTextId = [
    {
        id: fiCustomerPaymentStatus.Freemium,
        textId: 'Freemium',
    },
    {
        id: fiCustomerPaymentStatus.Paying,
        textId: 'Paying',
    },
];

const fiCustomerPaymentStatusMap = createMap(fiCustomerPaymentStatuses, 'id');
export function fiCustomerPaymentStatusName(customerPaymentStatus: fiCustomerPaymentStatus, appText: AppTextService) {
    if (fiCustomerPaymentStatusMap.hasOwnProperty(customerPaymentStatus))
        return fiCustomerPaymentStatusMap[customerPaymentStatus].textId;

    throw 'FI: unknown payments customer status ' + customerPaymentStatus;
}
